// extracted by mini-css-extract-plugin
export default {"Heading":"Title-module__Heading--saopa"};